
export const footer = ()=> {
    let footerTrigger;
    const footerLogo = document.querySelector('.footer__logo')
    const main = document.querySelector('.site-main')

    const func = ()=> {
        if (footerLogo) {
            if (footerTrigger) {
                footerTrigger.kill();
            }

            const footer = document.querySelector('.footer');
            const trigger = window.innerHeight <= footer.offsetHeight ? footerLogo : main;
            const startPosition = window.innerHeight <= footer.offsetHeight ? `top 80%` : 'bottom 50%';

            footerTrigger = ScrollTrigger.create({
                trigger: trigger,
                start: startPosition,
                end: 'bottom 10%',
                onEnter: () => {
                    footerLogo.classList.add('play');
                },
                onLeaveBack: () => {
                    footerLogo.classList.remove('play');
                },
            });
        }
    }

    func()

    addEventListener('resize',()=> {
        func()
    })

}